import { setConquistaUsuario } from '../requests/simulado.request';
import * as GamificacaoRequest from '../requests/gamificacao.request';

let _question = {}
let _simulado

const salvarEvento = (event) => {
    setConquistaUsuario(event, `simulado/${_simulado}/video/${_question.id}`)

    if(event === EVENT_TYPES.WATCHED_70_PERCENT || event === EVENT_TYPES.ENDED) {
        GamificacaoRequest.calcularPontuacaoUsuario()
    }
}

const Events = {
    onPlayed() {
        // console.log('played the video!', EVENT_TYPES.PLAY, _question, _simulado);
        salvarEvento(EVENT_TYPES.PLAY)
    },
    on50PercentWatched() {
        // console.log('50% watched', EVENT_TYPES.WATCHED_50_PERCENT, _question, _simulado)
        salvarEvento(EVENT_TYPES.WATCHED_50_PERCENT)
    },
    on70PercentWatched() {
        // console.log('70% watched', EVENT_TYPES.WATCHED_70_PERCENT, _question, _simulado)
        salvarEvento(EVENT_TYPES.WATCHED_70_PERCENT)
    },
    onEnded() {
        // console.log('Ended', EVENT_TYPES.ENDED, _question, _simulado)
        salvarEvento(EVENT_TYPES.ENDED)
    }
}

const EVENT_TYPES = {
    PLAY: 'av001',
    WATCHED_50_PERCENT: 'av002',
    WATCHED_70_PERCENT: 'av003',
    ENDED: 'av004'
}

export default (simulado) => {
    _simulado = simulado
    return {
        forQuestion(question) {
            _question = question
            return Events
        }
    }
}